export const PDP_TRADE_ON_APPROVAL_VIEW_COUNT_STORAGE_KEY = 'pdpTradeOnApproval_localStorageKey';
export const PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_DISMISSED =
    'pdp_trade_on_approval_coachmark_tooltip_dimissed';
export const PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_MAX_VIEWS = 4;
